<template>
  <div class="card listing-card">
    <form @submit.prevent class="needs-validation" novalidate>
      <div v-if="serverError" class="alert alert-danger" role="alert">
        {{serverError}}
      </div>
      <div class="card-body">
        <div class="label-text">
          <span v-if="isAdd">Assign Reviewer</span>
          <span v-if="!isAdd">Edit Review</span>
        </div>
        <hr/>
        <div class="form-group row" v-if="isAdd">
          <label for="assignee" class="col-lg-4 label-text">
            <span class="text-danger">*</span>Assign To
          </label>
          <div class="loading col-lg-5" v-if="loadingUsers">
            Loading...
          </div>
          <div class="col-lg-8">
            <select v-if="!loadingUsers"
              v-validate="'required'"
              data-vv-as="Assignee"
              class="form-control"
              name="assigneeId"
              v-model="selectedUsers[0].id">
              <option value="" disabled>Select Assignee</option>
              <option v-for="option in unselectedAssignees(selectedUsers[0].id)"
                :key="option.id"
                :value="option.id">
                {{ option.name }}
              </option>
            </select>
            <div class="invalid-feedback">{{ errors.first('assigneeId') }}</div>
          </div>
        </div>
        <div v-for='(user, index) in selectedUsers.slice(1)'
                  :key='index'>
          <div class="form-group row">
            <div class="col-lg-4 label-text">
              <span v-if='index === 0'>Additional Assignees</span>
            </div>
            <div class="input-group col-lg-8">
              <select v-if="!loadingUsers"
                      v-validate="'required'"
                      data-vv-as="Additional Assignees"
                      class="form-control"
                      name="user"
                      v-model="user.id">
                <option value="" disabled>Select Assignee</option>
                <option v-for="option in unselectedAssignees(user.id)"
                        :key="option.id"
                        :value="option.id">
                {{ option.name }}
                </option>
              </select>
              <a class="form-action-icon text-danger"
                    @click='removeAdditionalAssignee(index + 1)'>
                <font-awesome-icon icon='trash-alt' />
              </a>
              <div class="invalid-feedback" v-if="errors.first('additionalLocale')">
                Select Additonal Locality or remove this row.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row" v-if="isAdd">
          <div class="col-lg-4 offset-lg-8">
            <b-button v-if="isAdd" size="sm" class="float-right" @click="addAdditionalAssignee()">
              Add Additional Assignee
            </b-button>
          </div>
        </div>

        <hr v-if="isAdd" />

        <div class="form-group row" v-if="isAdd">
          <label for="instructions" class="col-lg-4 col-form-label label-text">
            <span class="text-danger">*</span>Review Instructions
          </label>
          <div class="col-lg-8">
            <textarea data-vv-as="Review Instructions"
                      v-validate="'required|min:3'"
                      type="textarea"
                      class="form-control"
                      name="instructions"
                      v-model="review.instructions"
                      placeholder="Enter Instructions"
                      rows="2"
                      maxlength="256" />
              <small v-if="!errors.first('instructions')" class="form-text text-muted">
                Max 256 characters
              </small>
              <div class="invalid-feedback">{{ errors.first('instructions') }}</div>
          </div>
        </div>

        <div class="form-group row" v-if=!isAdd>
          <label class="col-lg-4 label-text">
            Reviewer
          </label>
          <div class="col-lg-8">
            {{ review.assigneeName }}
          </div>
        </div>
        <div class="form-group row" v-if=!isAdd>
          <label class="col-lg-4 label-text">
            Assigned By
          </label>
          <div class="col-lg-8">
            {{ review.assignerName }}
          </div>
        </div>
        <div class="form-group row" v-if=!isAdd>
          <label class="col-lg-4 label-text">
            Open Date
          </label>
          <div class="col-lg-8">
            {{ review.openDate | dateStringNullIsNA }}
          </div>
        </div>
        <div class="form-group row" v-if=!isAdd>
          <label class="col-lg-4 label-text">
            Close Date
          </label>
          <div class="col-lg-8">
            {{ review.closeDate | dateStringNullIsNA }}
          </div>
        </div>
        <div class="form-group row" v-if=!isAdd>
          <label class="col-lg-4 label-text">
            Review Status
          </label>
          <div class="loading col-lg-5" v-if="reviewStatusesLoading">
            Loading...
          </div>
          <div v-if="!reviewStatusesLoading" class="col-lg-8">
            <template v-if="isAssigner(review) || isAssignee(review)|| isUserAdmin()">
              <select
                      data-vv-as="Status"
                      class="form-control"
                      name="reviewStatus"
                      v-model="review.reviewStatusId">
                <option v-for="option in reviewStatuses"
                        :key="option.id"
                        :value="option.id"
                        :disabled="!isAssigner(review) && option.id==4 && !isUserAdmin()||
                        isAssigner(review) && option.id!=4 &&
                        isAssigner(review)!=isAssignee(review) && !isUserAdmin() ">
                  {{ option.name }}
                </option>
              </select>
              <label class="small text-muted" v-if="isCompleteSelected">
                Please add a relevant Event (as needed) to document progress related to your Review.
              </label>
            </template>
            <template v-else>
              {{ getReviewStatusName(review.reviewStatusId) }}
            </template>
          </div>
        </div>
        <div class="form-group row" v-if=!isAdd>
          <label class="col-lg-4 label-text">
            Review Instructions
          </label>
          <div v-if="isAssigner(review) || isUserAdmin()" class="col-lg-8">
            <textarea data-vv-as="Notes"
              type="textarea"
              class="form-control"
              name="notes"
              v-model="review.instructions"
              :placeholder="review.instructions"
              rows="2"
              maxlength="256" />
            <small v-if="!errors.first('notes')" class="form-text text-muted">
              Max 256 characters
            </small>
            <div class="invalid-feedback">{{ errors.first('notes') }}</div>
          </div>
          <div v-else class="col-lg-8">
            {{ review.instructions || 'None' }}
          </div>
        </div>
        <div class="form-group row" v-if=!isAdd>
          <label class="col-lg-4 label-text">
            Reviewer Comments
          </label>
          <div v-if="isUserAdmin() || isAssignee(review)"
          class="col-lg-8">
            <textarea data-vv-as="Notes"
              type="textarea"
              class="form-control"
              name="notes"
              v-model="review.comments"
              :placeholder="review.comments"
              rows="2"
              maxlength="250" />
            <small v-if="!errors.first('notes')" class="form-text text-muted">
              Max 250 characters
            </small>
            <div class="invalid-feedback">{{ errors.first('notes') }}</div>
          </div>
          <div v-else class="col-lg-8">
            {{ review.comments || 'None' }}
          </div>
        </div>
      </div>
      <div class='card-footer right-align-content'>
        <b-button
          :disabled="submitting"
          variant="danger" class="button-row-spacing"
          v-b-modal="'cancelReviewConfirmation-' + review.id">
          Cancel
        </b-button>
        <b-button
          :disabled="submitting"
          @click="submitWrapper()">
          Save
        </b-button>
      </div>
    </form>
    <CancelModal
      :modalId="'cancelReviewConfirmation-' + review.id"
      @cancelled="cancelEdit">
    </CancelModal>
    <DeleteModal
      modalId="withdrawReview"
      deleteDisplayName="Withdraw a Review"
      :deletePrompt="warningMessage"
      @deleteConfirmed="submitConfirmed()">
    </DeleteModal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { EntityModules } from '@/store/moduleConfig';
import FormSubmit from '../../mixins/FormSubmit';
import CancelModal from '../CancelModal.vue';
import DeleteModal from '../DeleteModal.vue';

export default {
  name: 'ReviewForm',
  components: {
    CancelModal,
    DeleteModal,
  },
  data() {
    return {
      selectedUser: '',
      selectedUsers: [{ id: '', name: '' }],
      review: {
        id: this.existingReview.id,
        serviceId: this.existingReview.serviceId,
        instrumentId: this.existingReview.instrumentId,
        reviewStatusId: this.existingReview.reviewStatusId,
        assigneeId: this.existingReview.assigneeId,
        assigneeName: this.existingReview.assigneeName,
        assignerId: this.existingReview.assignerId,
        assignerName: this.existingReview.assignerName,
        assigneeIds: [],
        openDate: this.existingReview.openDate,
        closeDate: this.existingReview.closeDate,
        instructions: this.existingReview.instructions,
        comments: this.existingReview.comments,
      },
      warningMessage: 'If you withdraw a Review, it will be deleted. Are you sure you want to withdraw this Review?',
    };
  },
  mixins: [FormSubmit],
  props: [
    'existingReview',
    'reviewStatuses',
    'reviewStatusesLoading',
    'storeNamespace',
    'parentId',
  ],
  mounted() {
    this.$store.dispatch('User/fetchActiveUsers');
  },
  computed: {
    ...mapState('User', {
      activeUsers: state => state.activeUsers,
      loadingUsers: state => state.loading,
      serverError: state => state.serverError,
      user: state => state.user,
    }),
    ...mapGetters('User', {
      getUserName: 'getUserName',
    }),
    submitting() {
      return this.$store.state[this.storeNamespace].submitting;
    },
    isAdd() {
      return !this.review.id;
    },
    isCompleteSelected() {
      return this.review.reviewStatusId === 2;
    },
  },
  methods: {
    addAdditionalAssignee() {
      this.selectedUsers.push({ id: '', name: '' });
    },
    unselectedAssignees(userId) {
      return this.activeUsers.filter(option => userId === option.id
        || (option.id !== this.selectedUsers[0].localityId
          && this.selectedUsers && !this.selectedUsers.some(user => option.id === user.id)));
    },
    removeAdditionalAssignee(index) {
      this.selectedUsers.splice(index, 1);
    },
    cancelEdit() {
      this.$emit('closeForm', this.review.id);
    },
    submitConfirmed() {
      const review = {};
      Object.assign(review, this.review);
      if (this.isAdd) {
        // const mappedUsers = this.selectedUsers.map(x => ({ id: x.id, name: this.activeUsers.find(y => y.id === x.id).name }));

        review.assigneeIds = this.selectedUsers.map(x => x.id);
      }
      this.onSubmitToStore(
        review,
        this.storeNamespace,
        'review',
        null,
        this.submitCallback,
      );
    },
    submitWrapper() {
      if (this.review.reviewStatusId === 4) {
        this.$bvModal.show('withdrawReview');
      } else {
        this.submitConfirmed();
      }
    },
    submitCallback() {
      let eventStoreConfig = EntityModules.SERVICE_EVENT;
      let reviewStoreConfig = EntityModules.SERVICE_REVIEW;
      if (this.storeNamespace === EntityModules.INSTRUMENT_REVIEW.namespace) {
        eventStoreConfig = EntityModules.INSTRUMENT_EVENT;
        reviewStoreConfig = EntityModules.INSTRUMENT_REVIEW;
      }
      this.$store.dispatch(`${reviewStoreConfig.namespace}/fetchEntities`, {
        parentType: reviewStoreConfig.parentType,
        parentId: this.parentId,
        entityType: reviewStoreConfig.entityType,
        forceLoad: true,
      });
      this.$store.dispatch(`${eventStoreConfig.namespace}/fetchEntities`, {
        parentType: eventStoreConfig.parentType,
        parentId: this.parentId,
        entityType: eventStoreConfig.entityType,
        forceLoad: true,
      });
      this.$store.dispatch(`${EntityModules.OPEN_REVIEWS.namespace}/fetchEntities`, {
        parentType: EntityModules.OPEN_REVIEWS.parentType,
        parentId: parseInt(this.$route.params.project_id, 10),
        entityType: EntityModules.OPEN_REVIEWS.entityType,
        forceLoad: true,
      });
    },
    isAssigner(entity) {
      return this.user.idToken.oid === entity.assignerId;
    },
    isAssignee(entity) {
      return this.user.idToken.oid === entity.assigneeId;
    },
    isUserAdmin() {
      return this.user.idToken.roles.includes('Admin');
    },
    getReviewStatusName(id) {
      const reviewStatus = this.reviewStatuses.filter(p => p.id === id)[0];
      return reviewStatus ? reviewStatus.name : 'None';
    },
  },
};
</script>
